<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd"
         style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4"
                class="search-nav-left">
          <i class="el-icon-search"
             style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20"
                class="search-nav-right">
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="hide">收起查询</el-button>
          <el-button class="search-open-close"
                     type="text"
                     @click="hide=!hide"
                     v-show="!hide">展开查询</el-button>
          <i v-if="hide === true"
             class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false"
             class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new"
                     type="primary"
                     size="small"
                     @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide"
             class="search-content common-search-formtype">
          <el-form :inline="true"
                   :model="formInlineTmp"
                   label-width="95px"
                   class="search-content-item">
            <el-form-item label="美食名称：">
              <el-input @keyup.enter.native="searchLoad"
                        v-model.trim="formInlineTmp.foodName"
                        placeholder="请输入美食名称"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="活动名称：">
              <el-input @keyup.enter.native="searchLoad"
                        v-model.trim="formInlineTmp.name"
                        placeholder="请输入活动名称"
                        clearable></el-input>
            </el-form-item>

            <el-form-item label="报名时间：">
              <el-date-picker class="micro-page-picker"
                              style="width:350px!important;margin-top: 12px"
                              v-model="timePickerDate"
                              @blur="verifyTime"
                              range-separator="至"
                              type="datetimerange"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              format="yyyy-MM-dd HH:mm:ss"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-form-item>

          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top"
            style="padding-right:0">
      <el-col :span="4"
              style="text-align: left;">
        <i class="el-icon-document"
           style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>

    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData"
                v-loading="loading"
                class="table">
        <template slot="empty">
          <div class="newTableEmpty">没有更多数据了</div>
        </template>
        <el-table-column prop="foodName"
                         label="美食名称">
        </el-table-column>

        <el-table-column prop="foodDesc"
                         label="美食描述">
        </el-table-column>

        <el-table-column prop="chefName"
                         label="厨师姓名">
        </el-table-column>

        <el-table-column prop="chefPhone"
                         label="厨师联系方式">
        </el-table-column>

        <el-table-column prop="takeName"
                         label="拍摄者姓名">
        </el-table-column>
        <el-table-column prop="takePhone"
                         label="拍摄者联系方式">
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope" class="">
            <span :class="scope.row.status == 0 ?'pointGreen':'pointRed'"></span>{{ scope.row.status == 0 ? '有效' : '无效' }}
          </template>
        </el-table-column>

        <el-table-column prop="createTime"
                         label="报名时间">
        </el-table-column>
        <!-- <el-table-column prop="remark"
                         label="备注">
        </el-table-column> -->
        <el-table-column prop="name"
                         label="活动名称">
        </el-table-column>
        <el-table-column label="操作"
                         width="100">
          <template slot-scope="scope">
            <!-- <div class="op-link"
                 @click="download(scope.row.videoUrl)">
              下载测
            </div> -->
            <!-- <div class="op-link">
              <a :href="scope.row.videoUrl"
                 target="_blank">下载</a>
            </div> -->
            <div class="op-link"
                 v-if="butsObj.download" @click="downVideo(scope.row.videoUrl,scope.row.foodName)">
              下载
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination"
                       background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-size="limit"
                       layout="total, prev, pager, next, jumper"
                       :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getVideoList } from '@/api/video-activity.js'
import { butonsList, getMenId } from '@/api/analyse.js'
export default {
  name: '',
  data () {
    return {
      hide: true,
      tableData: [],
      totalCount: 0,
      companyId: Lockr.get('userInfo').id,
      limit: 10,
      page: 1,
      loading: false,
      formInlineTmp: {
        name: '',
        foodName: ''
      },
      timePickerDate: [],
      butsObj: {
       download: false
     }
    }
  },
  methods: {
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    searchLoad () {
      // console.log(this.timePickerDate)
      this.page = 1
      this.getData()
    },
    getData () {
      this.loading = true
      var params = {
        // companyId: this.companyId,
        page: this.page,
        limit: this.limit,
        name: this.formInlineTmp.name,
        foodName: this.formInlineTmp.foodName,
        startTime: this.timePickerDate[0],
        activityId: '',
        endTime: this.timePickerDate[1]
      }
      getVideoList(params).then(res => {
        this.tableData = res.data.result.list
        this.totalCount = res.data.result.total
      })
      this.openLoading()
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
    },
    handleCurrentChange (page) {
      this.page = page
      this.getData()
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    verifyTime () {
      if (Date.parse(new Date(this.timePickerDate[0])) > Date.parse(new Date(this.timePickerDate[1]))) {
        _g.toastMsg('error', '开始时间不能晚于结束时间')
      }
    },

    downVideo (url, foodName) {
      if (!url) {
        return
      }
      // 获取文件后缀
      var index = url.lastIndexOf('.')
      var ext = url.substr(index + 1)
      if (!this.isVideoType(ext)) {
        ext = 'mp4'
      }

      var xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.responseType = 'blob'  // 返回类型blob
      xhr.onload = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          let blob = this.response
          // 转换一个blob链接
          let u = window.URL.createObjectURL(new Blob([blob]))
          let a = document.createElement('a')
          a.download = foodName + '.' + ext
          a.href = u
          a.style.display = 'none'
          document.body.appendChild(a)
          a.click()
          a.remove()
        }
      }
      xhr.send()
    },
    /*
    * 根据文件名的尾缀 判断是否为视频
    * @param {any} videoType 文件名后缀
    */
    isVideoType (videoType) {
      let result = ''
      if (!videoType) { return false }
      videoType = videoType.toLocaleLowerCase()
      // 匹配视频
      const videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v']
      result = videolist.find(item => item === videoType)
      if (result) {
        return true
      }
      return false
    }
  },
  watch: {
    'timePickerDate' (newVal) {
      if (newVal == null) {
        this.timePickerDate = []
      }
    }
  },
  mounted () {
    this.getButtonsList()
    this.getData()
  },
  computed: {

  },
  created () {

  }
}
</script>

<style scoped>
</style>
